import { Formik } from "formik";
import React, { useEffect } from "react";
import { FaFacebookF, FaGoogle, FaTwitter } from "react-icons/fa";
import RegularButton from "../../components/Buttons/RegularButton";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserData } from "../../redux/slices/authSlice";
import { TextField } from "@mui/material";
import Twitter from "../../assets/twiter.png";
import Google from "../../assets/google..png";
import Facebook from "../../assets/facebook.png";
import { useFindCustomerDetailByIdMutation } from "../../redux/services/customerService";
import { setCustomer } from "../../redux/slices/customerSlice";

type Props = {};

const Finish = (props: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(getUserData);
  console.log( user ,"user");
    const [findByCustomerId, findByCustomerIdResponse] = useFindCustomerDetailByIdMutation();
  const handleLoginSubmit = () => {
    if (user.customerId) {
      findByCustomerId({ token: user.jwtToken, id: user.customerId });
    }
  };

 
    useEffect(() => {
      if (findByCustomerIdResponse.isSuccess) {
        dispatch(setCustomer(findByCustomerIdResponse.data));
        localStorage.setItem(
          "customerDetail",
          JSON.stringify(findByCustomerIdResponse.data)
        );
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("isLoggedIn", "true");
        const previousPath = localStorage.getItem("redirectAfterLogin") || "/";
        console.log(previousPath, "previousPath");
        navigate(previousPath);
      }
  
    }, [findByCustomerIdResponse.isSuccess, findByCustomerIdResponse.isError]);
  


  return (
    <div className="bg-[#F9F4EF] w-full">
      <div className="relative w-full flex lg:hidden justify-center items-center pt-10">
        <img
          src={require("../../assets/login.png")}
          className="w-full sm:w-[500px] md:w-[600px]  md:max-h-[500px] object-cover"
          alt="Auth Illustration"
        />

        {/* Overlayed Text (Responsive for Mobile & Tab) */}
        <div className="absolute top-12 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full px-4">
          <h2 className="text-xl sm:text-2xl md:text-4xl text-black">WEEKEND GETAWAY</h2>
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black mt-2">
            Grab Up to 40% OFF*
          </h1>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row h-screen">
        <div className="w-full lg:w-[40%] flex flex-col justify-center items-center p-4">
          <div className="max-w-[400px] w-full">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-gray-700">
                ca<span className="font-extrabold">RENT</span>al
              </h1>
              <h2 className="text-2xl font-semibold text-black mt-2">Registration completed!</h2>
            </div>
            <Formik
              initialValues={{
                userName: user.name,
                Email: user.email,
              }}
              onSubmit={handleLoginSubmit}
            >
              {({
                handleBlur,
                handleChange,
                handleSubmit,
                values,
              }) => (
                <div >
                  <div className="mt-3">
                    <TextField
                      color="error"
                      label="Name"
                      variant="outlined"
                      size="small"
                      type="text"
                      id={"userName"}
                      name={"userName"}
                      value={values.userName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter your name"
                      className="w-full mt-1"
                      sx={{
                        backgroundColor: "#E2E2E2",
                        borderRadius: "30px",
                        mb: 2,
                        height: "45px", // Slightly reduced height for a compact look
                        "& .MuiInputBase-root": {
                          display: "flex",
                          alignItems: "center", // Centers input text vertically
                          height: "100%",
                          padding: "0 12px", // Reducing padding inside input container
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "30px",
                          height: "100%",
                          "& input": {
                            padding: "6px 8px", // Reduced padding inside input field
                          },
                          "& fieldset": { borderColor: "transparent" },
                          "&:hover fieldset": { borderColor: "transparent" },
                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                        },
                        "& .MuiInputLabel-root": {
                          top: "50%",
                          left: "12px", // Moves label closer to start
                          transform: "translateY(-50%)", // Centers label vertically
                        },
                        "& .MuiInputLabel-shrink": {
                          top: 6, // Moves label up when focused
                          transform: "translateY(-100%) scale(0.75)",
                        },
                        "& .MuiFormHelperText-root": {
                          position: "absolute",
                          bottom: "-18px", // Adjusted for better spacing
                          fontSize: "12px",
                          color: "red",
                        },
                      }}
                    />
                  </div>
                  <div className="mt-3">
                    <TextField
                      color="error"
                      label="Email"
                      size="small"
                      variant="outlined"
                      type="text"
                      id={"Email"}
                      name={"Email"}
                      value={values.Email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter your email"
                      className="w-full mt-1"
                      sx={{
                        backgroundColor: "#E2E2E2",
                        borderRadius: "30px",
                        mb: 2,
                        height: "45px", // Slightly reduced height for a compact look
                        "& .MuiInputBase-root": {
                          display: "flex",
                          alignItems: "center", // Centers input text vertically
                          height: "100%",
                          padding: "0 12px", // Reducing padding inside input container
                        },
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "30px",
                          height: "100%",
                          "& input": {
                            padding: "6px 8px", // Reduced padding inside input field
                          },
                          "& fieldset": { borderColor: "transparent" },
                          "&:hover fieldset": { borderColor: "transparent" },
                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                        },
                        "& .MuiInputLabel-root": {
                          top: "50%",
                          left: "12px", // Moves label closer to start
                          transform: "translateY(-50%)", // Centers label vertically
                        },
                        "& .MuiInputLabel-shrink": {
                          top: 6, // Moves label up when focused
                          transform: "translateY(-100%) scale(0.75)",
                        },
                        "& .MuiFormHelperText-root": {
                          position: "absolute",
                          bottom: "-18px", // Adjusted for better spacing
                          fontSize: "12px",
                          color: "red",
                        },
                      }}
                    />
                  </div>
                  <div className="flex items-center gap-5 mt-5">
                    <RegularButton
                      onClick={handleSubmit}
                      className="w-full md:w-[400px] "
                      title={"Finish"}
                    />
                  </div>
                  <div>
                    <div className="flex items-center w-full">
                      <div className="border-t-2 w-[33%]"></div>
                      <p className="mb-0 text-center text-[11px] md:text-[16px] w-[33%] text-gray-500 py-4">
                        Or Sign up with
                      </p>
                      <div className="border-b-2 w-[33%]"></div>
                    </div>
                    <p className="mb-0 text-center text-gray-500 py-6 cursor-default ">
                      Already have an account?{" "}
                      <span
                        className="text-red-500 cursor-pointer"
                        onClick={() => {
                          navigate("/profile/auth/login");
                        }}
                      >
                        Sign in
                      </span>
                    </p>
                  </div>
                </div>
              )}
            </Formik>
          </div>
        </div>
        <div className="relative w-full lg:w-[60%] hidden lg:flex justify-center items-center p-4">
          <img
            src={require("../../assets/login.png")}
            className="w-[600px] max-h-[300px] md:max-h-[500px] object-cover"
            alt="Auth Illustration"
          />

          {/* Overlayed Text (Centered Properly) */}
          <div className="absolute top-28 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center w-full px-4">
            <h2 className="text-4xl text-black whitespace-nowrap">WEEKEND GETAWAY</h2>
            <h1 className="text-5xl font-bold text-black mt-2 whitespace-nowrap">
              Grab Up to 40% OFF*
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Finish;
